import {
  Navigate,
  useOutlet,
  useLocation,
} from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { hasValidAuthSession } from '../utils/unauthorizedSession';

export const PublicLayout = ({ isLoading }) => {
  const { userData } = useAuth();

  const outlet = useOutlet();
  const location = useLocation();
  const search = location.search || '';
  const authenticatedLandingPath = '/ChatSocket';
  const pathname = location.pathname.toLowerCase();
  const hasAuthenticatedSession = Boolean(userData) && hasValidAuthSession();

  if (pathname === '/' && !isLoading) {
    const landingPath = hasAuthenticatedSession ? authenticatedLandingPath : '/SignIn';
    return <Navigate to={`${landingPath}${search}`} replace />;
  }

  if (hasAuthenticatedSession && !isLoading && pathname !== '/signin') {
    return <Navigate to={`${authenticatedLandingPath}${search}`} replace />;
  }

  return <div style={{ height: '100%', width: '100%', overflow: 'auto' }}>{outlet}</div>;
};
